var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "rounded-lg shadow-md p-3 sm:p-4 flex items-center justify-center sm:justify-between sm:flex-row flex-col flex-wrap bg-white",
    },
    [
      _c(
        "div",
        { staticClass: "mb-2 sm:mb-0 flex flex-col gap-6 w-full" },
        [
          _c(
            "div",
            {
              staticClass:
                "flex flex-col md:flex-row items-stretch text-xl text-gray-900 relative",
            },
            [
              _vm._t("avatar"),
              _c("div", { staticClass: "w-full" }, [
                _c(
                  "div",
                  { staticClass: "flex flex-row items-start" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col mr-4 titleWidth w-full overflow-auto",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center wrapItem" },
                          [
                            _vm.title
                              ? _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "font-bold card-title text-gray-900 mr-4 flex items-center",
                                  },
                                  [
                                    _c("span", [_vm._t("chip")], 2),
                                    _vm._v(" " + _vm._s(_vm.title) + " "),
                                  ]
                                )
                              : _vm._e(),
                            _vm._t("status"),
                          ],
                          2
                        ),
                        _c("div", {}, [_vm._t("role")], 2),
                      ]
                    ),
                    _vm._t("actions"),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "flex flex-col flex-wrap" },
                  [_vm._t("icons")],
                  2
                ),
              ]),
            ],
            2
          ),
          _vm._t("annotation"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }